import { ISupportMessage } from "../../models/chatModels";

const ANONYMOUS_USER_ID_KEY = "anonymous";
const MESSAGES_SESSION_KEY = "findpro_anonymous_support_messages";

interface StoredAnonymousSupportSession {
    anonymousId: string;
    messages: ISupportMessage[];
}

export const getOrCreateAnonymousUserId = (): string => {
    let anonymousUserId = localStorage.getItem(ANONYMOUS_USER_ID_KEY);

    if (!anonymousUserId) {
        anonymousUserId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;

            return v.toString(16);
        });
        localStorage.setItem(ANONYMOUS_USER_ID_KEY, anonymousUserId);
    }

    return anonymousUserId;
};

export const loadAnonymousSupportMessages = (anonymousId: string): ISupportMessage[] => {
    try {
        const raw = sessionStorage.getItem(MESSAGES_SESSION_KEY);

        if (!raw) {
            return [];
        }

        const parsed = JSON.parse(raw) as StoredAnonymousSupportSession;

        if (parsed.anonymousId !== anonymousId || !Array.isArray(parsed.messages)) {
            return [];
        }

        return parsed.messages;
    } catch {
        return [];
    }
};

export const saveAnonymousSupportMessages = (
    anonymousId: string,
    messages: ISupportMessage[],
): void => {
    if (!messages.length) {
        sessionStorage.removeItem(MESSAGES_SESSION_KEY);

        return;
    }

    const payload: StoredAnonymousSupportSession = {
        anonymousId,
        messages,
    };

    sessionStorage.setItem(MESSAGES_SESSION_KEY, JSON.stringify(payload));
};
